/** zh-CN catalogue `ease` (W3-09; English: src/core/ease/ease.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'ease',
  locale: 'zh-CN',
  messages: {
    unknownEasing: '未知的缓动编号 {id}。RPE 缓动的编号为 1 到 29。',
    sliceOutOfRange: '要使用的曲线部分必须在 0 到 1 之间。',
    sliceEmpty: '曲线部分的起点必须在终点之前。',
    sliceDegenerate: '曲线的这一部分起点和终点高度相同，Phira 无法拉伸它，将不显示任何运动。请选择其他部分。',
    bezierNotFinite: '自定义曲线有一个控制柄的位置无效。',
    bezierXOutOfRange: '自定义曲线的控制柄在水平方向上必须保持在 0 到 1 之间。',
    noBezierOnSpeed: '流速不能使用自定义曲线：Phira 会崩溃。请改用带编号的缓动。',
    speedGuidedLinearOnly:
      'Phira 将流速变化播放为直线渐变。请选择“线性”或“钩定”，或切换到完整模式以使用其他缓动（导出时会被烘焙）。',
    textRevealOvershoot: '用超出起点或终点的缓动来逐字显示或擦除文字时，Phira 会崩溃。请选择不超出范围的缓动。',
    controlNoBezier: '距离控制只支持带编号的 RPE 缓动，不支持自定义曲线。',
    controlNoHold: '距离控制不能使用钩定。请选择带编号的 RPE 缓动。',
    controlNoSlice: '距离控制总是使用整条曲线。请移除部分范围。',
    extraVarNoBezier: '特效和视频的数值不能使用自定义曲线：extra.json 不支持自定义曲线。请改为烘焙运动。',
    'name.linear': '线性',
    'name.hold': '钩定（保持后跳变）',
    'name.bezier': '自定义曲线',
    'family.linear': '线性',
    'family.sine': '正弦',
    'family.quad': '二次',
    'family.cubic': '三次',
    'family.quart': '四次',
    'family.quint': '五次',
    'family.expo': '指数',
    'family.circ': '圆形',
    'family.back': '回退',
    'family.elastic': '弹性',
    'family.bounce': '弹跳',
    'strength.gentle': '轻柔',
    'strength.soft': '柔和',
    'strength.medium': '适中',
    'strength.strong': '较强',
    'strength.stronger': '更强',
    'strength.extreme': '极强',
    'strength.sharp': '陡峭',
    'strength.overshoot': '过冲',
    'strength.springy': '弹簧',
    'strength.bouncy': '弹跳',
    'shape.slowStart': '慢起',
    'shape.slowEnd': '慢停',
    'shape.slowBoth': '两端慢',
    'variant.in': '缓入',
    'variant.out': '缓出',
    'variant.inout': '缓入缓出',
    'note.differsInRpe': 'Phira 绘制此缓动的方式与 RPE 不同。',
    'note.overshoots': '此缓动会超出起始值或结束值。',
    'note.approxBezier': 'RPE 中没有此缓动的编号：它以拟合的自定义曲线提供（最大偏差 {error}%）。',
    'note.splitApprox': '拆分后的运动与原来的偏差在 {percent}% 以内。',
    'note.splitBake': '此区段的一部分无法精确拆分，将被烘焙为直线分段。',
  },
};

export default catalog;
